module.exports = __webpack_public_path__ + "static/media/8.e73ebb2e.jpg";